import moment from 'moment'
import Vue from 'vue'

moment.locale('fr')
Vue.prototype.moment = moment
